import React from "react";

export type TVersionControlConfig = {
  routeBlackList: string[];
  modulesBlockFlags: string[];
  specificSet: any;
};

type TVersionContext = {
  state: {
    fallBackVersionControl: TVersionControlConfig;
    actualVersionControl?: TVersionControlConfig;
  };
  setState: React.Dispatch<{
    fallBackVersionControl: TVersionControlConfig;
    actualVersionControl?: TVersionControlConfig;
  }>;
};

export const DEFAULT_VERSION_CONTEXT_STATE = {};
/**
 * Контекст для контроля и отключения модулей в сборке
 * используется для сокрытия готового функционала от заказчика
 * (например если бюракратический вопрос касательно модуля урегулирован не был, а модуль уже разработан)
 *
 * !!! Иммутабельный, не редактируемый на прямую из кода. Задается в ручную здесь (для fallback) или с сервера. !!!
 *
 * !! Ограничения и блокировка обговариваются с руководителем проекта. !!
 * */

export const VersionContext = React.createContext<Partial<TVersionContext>>(
  DEFAULT_VERSION_CONTEXT_STATE
);
